<svg:g *ngFor="let trace of layer?.drawableTraces" [attr.transform]="layer.translate" [trace]="trace" ecg-trace></svg:g>
